import { OrganisationDetailResponse, UpdateOrganisationSsoRequest } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { OrganisationDetail, organisationDetailFromResponse } from './organisationDetails';

export interface UpdateOrganisationSSOPayload {
  organisationDisplayName: string;
  organisationSamlProviderName: string;
  metadataUrl: string | null;
  xmlMetadata: string | null;
  customClaimClients: string[];
}

export default class UpdateOrganisationSSO extends BaseAdapter<OrganisationDetailResponse> {
  rawResponse: OrganisationDetailResponse;

  modifiedRequest: UpdateOrganisationSsoRequest;

  async adaptResponse(
    payload: UpdateOrganisationSSOPayload,
  ): Promise<OrganisationDetail> {
    await this.fetchApiResponse(
      '/api/admin/organisation/sso',
      HTTPMethod.Patch,
      this.adaptRequest(payload)
    );
    return organisationDetailFromResponse(this.rawResponse);
  }

  adaptRequest(payload: UpdateOrganisationSSOPayload): UpdateOrganisationSsoRequest {
    this.modifiedRequest = {
      display_name: payload.organisationDisplayName,
      sso_configuration: {
        saml_provider_name: payload.organisationSamlProviderName,
        metadata_url: payload.metadataUrl,
        xml_metadata: payload.xmlMetadata,
        custom_claim_clients: payload.customClaimClients,
      },
    };
    return this.modifiedRequest;
  }
}
